import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { FEATURES } from "../../../utils/constant";
import { aesDecrypt } from "../../../utils/commonFunctionalities";

class Consignee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
    };
  }

  componentDidMount() {
    ReadAxios({ url: "consigneeMaster" })
      .then(async(dataArray) => {
        if(dataArray?.data?.resultSet?.length){
          for(let data of dataArray.data.resultSet){
            if(data.gstNumber) data.gstNumber = await aesDecrypt(data.gstNumber);
          }
          this.setState({
            rowData: dataArray.data.resultSet,
            loadingData: false,
          });
        }else{
          this.setState({
            rowData: [],
            loadingData: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_CONSIGNEE_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-consignee", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/consignee");
    this.props.history.go();
  };

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const Columns = [
      {
        headerName: t("table_header.consignee_code") || "Consignee Code",
        field: "consigneeCode",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.consignee_code") || "Consignee Id",
        field: "consigneeId",
        hide: true
      },
      {
        headerName: t("table_header.consignee_name") || "Consignee Name",
        field: "consigneeName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.city") || "City",
        field: "cityName",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.email_id") || "Email Id",
        field: "email",
        sortable: true,
        filter: true,
        // hide: true,
      },
      {
        headerName: t("table_header.mobile_number") || "Mobile Number",
        field: "phone",
        sortable: true,
        filter: true,
        // hide: true,
      },
      {
        headerName: t("table_header.landline_number") || "Landline Number",
        field: "landline",
        sortable: true,
        filter: true,
        hide: true
      },
      {
        headerName: t("table_header.gst") || "GST Number",
        field: "gstNumber",
        sortable: true,
        filter: true,
        // hide: true
      },
      {
        headerName: t("table_header.pan") || "PAN Number",
        field: "panNumber",
        sortable: true,
        filter: true,
        hide: true
      },
      {
        headerName: t("table_header.address") || "Consignee Address",
        field: "address",
        sortable: true,
        filter: true,
      },
      {
        headerName:
          t("table_header.checkpoint_latitude") || "Checkpoint Latitude",
        field: "checkPointLattitude",
        sortable: true,
        filter: true,
        // hide: true,
      },
      {
        headerName:
          t("table_header.checkpoint_longitude") || "Checkpoint Longitude",
        field: "checkPointLongitude",
        sortable: true,
        filter: true,
        // hide: true,
      },
      {
        headerName:
          t("table_header.checkpoint_radius") || "Checkpoint Radius",
        field: "checkPointRadius",
        sortable: true,
        filter: true,
        //hide: true,
      },
      {
        headerName:
          t("table_header.is_consignor") || "Is Consignor",
        field: "isConsignor",
        sortable: true,
        filter: true,
        // hide: true,
      },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_by") || "Modified By",
        field: "updatedBy",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.modified_on") || "Modified On",
        field: "updatedOn",
        sortable: true,
        filter: true,
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_CONSIGNEE_MASTER.UPDATE && !this.props.permissions.TA_CONSIGNEE_MASTER.DELETE,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={t("title") || "Consignee"}
          titleBarLink={"/add-consignee"}
          baseURL={"consigneeMaster"}
          pathName={"consigneeMaster"}
          keyIndex={"consigneeId"}
          onEdit={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          hideRowEdit={!this.props.permissions.TA_CONSIGNEE_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_CONSIGNEE_MASTER.DELETE}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("consignee_list")(Consignee));
